// Libraries
import { object, string } from 'yup'
// Constants
import { SUMMARY_MODAL_SIZES, Text } from '../../../../constants'

const NAME_VALIDATION_REGEX = /^[a-zA-Z\s-]*$/

const { maxLengthRole, maxLengthGrade, maxLengthCoreSkill, maxLengthSummary } = SUMMARY_MODAL_SIZES
const { Required, MaxLength, specialCharactersNotAllowed } = Text

export const SUMMARY_MODAL_SCHEMA = () =>
  object().shape({
    name: string().required(Required).matches(NAME_VALIDATION_REGEX, specialCharactersNotAllowed),
    lastName: string().required(Required).matches(NAME_VALIDATION_REGEX, specialCharactersNotAllowed),
    since: string().required(Required),
    role: string().required(Required).max(maxLengthRole),
    grade: string().required(Required).max(maxLengthGrade, MaxLength),
    coreSkill: string().required(Required).max(maxLengthCoreSkill, MaxLength),
    description: string()
      .required(Required)
      .max(maxLengthSummary, `Summary must be at most ${maxLengthSummary} characters`)
  })
